import { render, staticRenderFns } from "./ResponseTemplatesListTable.vue?vue&type=template&id=04a63b80&scoped=true&"
import script from "./ResponseTemplatesListTable.vue?vue&type=script&lang=js&"
export * from "./ResponseTemplatesListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a63b80",
  null
  
)

export default component.exports